import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterOption } from '../../../interfaces/filter-option.interface';

@Component({
  selector: 'filter-approval-status',
  templateUrl: './filter-approval-status.component.html',
  styleUrls: ['./filter-approval-status.component.scss']
})
export class FilterApprovalStatusComponent {
  @Input() selected: FilterOption[] = [];
  @Input() options: FilterOption[] = [];
  @Output() valueSelected = new EventEmitter<FilterOption[]>();
  open = false;

  handleSelected(option: FilterOption): void {
    if (this.selected.includes(option)) {
      this.selected = this.selected.filter(selected => selected.id !== option.id);
    } else {
      this.selected = [
        ...this.selected,
        option
      ];
    }
    
    this.valueSelected.emit(this.selected);
  }
}

